
import { QuestionContent } from "@/types/test";
import { Textarea } from "@/components/ui/textarea";

interface EssayQuestionProps {
  content: QuestionContent;
  response: string;
  onChange: (response: string) => void;
}

export function EssayQuestion({
  content,
  response,
  onChange,
}: EssayQuestionProps) {
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-2xl text-foreground">{content.question}</h3>
      <Textarea
        value={response || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Type your answer here..."
        className="min-h-[200px] bg-transparent border-border text-foreground placeholder:text-muted-foreground"
      />
    </div>
  );
}
